import { render, staticRenderFns } from "./PaymentsVouchers.vue?vue&type=template&id=313909df&"
import script from "./PaymentsVouchers.vue?vue&type=script&lang=js&"
export * from "./PaymentsVouchers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports